import React from 'react'
import { SolidUser } from '@rushable/icons'
import ConditionsItemForm from './ConditionsItemForm'
import type { TFilterItem } from '../help/constant'

export default function OnboardingAssigneeFilter({
  className,
  value,
  options,
  onChange,
}: TFilterItem) {
  return (
    <ConditionsItemForm
      className={className}
      icon={<SolidUser size={16} className='text-light-100' />}
      label='Onboarding assignee'
      value={value}
      options={options!}
      onChange={onChange}
    />
  )
}
